import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { TranslateUtil } from 'app/utils/translate.utils';
import { AppConstants } from '../../../app.constants';

@Component({
  standalone: false,
    selector: 'app-politica-privacidade',
    templateUrl: 'politica-privacidade.template.html',
    styleUrls: ['politica-privacidade.component.scss'],
})
export class PoliticaPrivacidadeComponent {

    public languages_options: any;
  public translateUtils: TranslateUtil = new TranslateUtil();

  public readonly translate = inject(TranslateService);
  public readonly toastr = inject(ToastrService);
  private readonly location = inject(Location);

    changeLanguage(language) {
        if (language == null || language == undefined) {
            language = AppConstants.LANGUAGES.PT_BR;
        }

        this.translate.use(language);
    }

    ok() {
    this.location.back();
    }

    voltar() {
        this.toastr.clear();
    this.location.back();
    }
}
